import { useTranslation } from "react-i18next"

const NoDocument = () => {
  const { t } = useTranslation()

  return (
    <div className="flex h-full flex-col items-center justify-center px-6 pb-12 text-center">
      <div className="text-on-surface text-xl font-bold">{t("patient.conclude.noDocuments.title")}</div>
      <div className="text-on-surface-subdued text-base">{t("patient.conclude.noDocuments.description")}</div>
    </div>
  )
}

export { NoDocument }
